<script>
  export default {
    props: {
      arquivos: {
        type: Array,
        required: true,
      },
      habilitarEditarDadosPessoaFisica: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data() {
      return {
        deletados: [],
      }
    },
    methods: {
      deletar(arquivo) {
        this.arquivos.splice(this.arquivos.indexOf(arquivo), 1);
        this.deletados.push(this.nomeArquivo(arquivo));
      },
      download(arquivo) {
        this.$emit('download', this.nomeArquivo(arquivo));
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      }
    }
  }
</script>

<template>
  <div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Arquivo</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="arquivo in arquivos">
          <td>{{ nomeArquivo(arquivo) }}</td>
          <td class="action">
            <button type="button" class="btn btn-xs btn-success" @click="download(arquivo)">
              <i class="fa fa-download"></i>
            </button>
            <button type="button" class="btn btn-xs btn-danger" @click="deletar(arquivo)"  v-if="habilitarEditarDadosPessoaFisica">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr v-if="arquivos.length === 0">
          <td colspan="2">Nenhum arquivo encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ListaDeArquivos.vue